import { useCallback, useEffect, useState } from 'react';
import { useViewport, useReactFlow } from 'reactflow';
import { inputValidation } from 'utils/commonUtils';

const useZoom = () => {
  const { zoom: currentZoom } = useViewport();
  const { zoomIn, zoomOut, zoomTo } = useReactFlow();
  const [zoom, setZoom] = useState(currentZoom);

  const handleZoomTo = useCallback(() => {
    zoomTo(zoom / 100);
  }, [zoom, zoomTo]);

  const handleZoomChange = useCallback((event: React.FormEvent<HTMLInputElement>) => {
    const {
      currentTarget: { value },
    } = event;

    const isValid = inputValidation(value, { type: 'int', min: 0 });
    if (isValid) {
      setZoom(Number(value));
    }
  }, []);

  const handleInputKeydown = useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === 'Enter') {
        handleZoomTo();
      }
    },
    [handleZoomTo]
  );

  const handleZoomIn = useCallback(() => {
    zoomIn();
  }, [zoomIn]);

  const handleZoomOut = useCallback(() => {
    zoomOut();
  }, [zoomOut]);

  useEffect(() => {
    setZoom(Math.round(currentZoom * 100));
  }, [currentZoom]);

  return {
    zoom,
    zoomIn,
    zoomOut,
    onZoomTo: handleZoomTo,
    onZoomChange: handleZoomChange,
    onInputKeydown: handleInputKeydown,
    onZoomIn: handleZoomIn,
    onZoomOut: handleZoomOut,
  };
};

export default useZoom;
